/* cc-rewards — member star balance (rolling count, cart-drawer style)
   + quick-link tiles that scroll to LoyaltyLion's sections.
   LL hydrates late and its data lands whenever it lands — everything
   here polls patiently and degrades quietly. */

(() => {
  if (window.ccInitGuardccRewards) return;
  window.ccInitGuardccRewards = true;

  const root = document.querySelector('.cc-rewards');
  if (!root) return;

  /* Tony round 9: DELETE LoyaltyLion's custom-CSS blob outright — the
     18KB #loyaltylion+!important style tag shipped in the page body
     kept out-tying our overrides. LL's functional widget CSS (CDN)
     stays; its THEMING dies here. Our #loyaltylion rules remain as a
     backstop for anything LL re-injects. */
  document.querySelectorAll('#MainContent style').forEach((st) => {
    if (st.textContent.indexOf('#loyaltylion') !== -1) st.remove();
  });

  /* ---- tiles: smooth-scroll to the LL section; hide tiles whose
     section never renders (e.g. History for guests) ---- */
  root.addEventListener('click', (e) => {
    const tile = e.target.closest('[data-cc-goto]');
    if (!tile) return;
    const target = document.querySelector(tile.dataset.ccGoto);
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  const pruneTiles = () => {
    root.querySelectorAll('[data-cc-goto]').forEach((t) => {
      const el = document.querySelector(t.dataset.ccGoto);
      t.hidden = !(el && el.offsetHeight > 0);
    });
  };

  /* ---- rolling star balance (same feel as the cart subtotal roll) ---- */
  const numEl = root.querySelector('[data-cc-stars]');
  const pendEl = root.querySelector('[data-cc-stars-pending]');
  const reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  const fmt = (n) => n.toLocaleString('en-US');
  let rolled = false;

  /* true ODOMETER (Tony round 3): each digit is a vertical strip that
     rolls to its target — rightmost columns spin through extra 0-9
     loops, all settle together (one shared ease). */
  function roll(to) {
    if (rolled) return;
    rolled = true;
    const str = fmt(to);
    if (reduced) {
      numEl.textContent = str;
      return;
    }
    numEl.textContent = '';
    numEl.classList.add('cc-odo');
    const chars = str.split('');
    const nDigits = chars.filter((ch) => /\d/.test(ch)).length;
    const strips = [];
    let di = 0;
    chars.forEach((ch) => {
      if (!/\d/.test(ch)) {
        const sep = document.createElement('span');
        sep.className = 'cc-odo__sep';
        sep.textContent = ch;
        numEl.appendChild(sep);
        return;
      }
      const target = parseInt(ch, 10);
      const loops = nDigits - 1 - di; /* leftmost rolls least, rightmost most */
      di += 1;
      const col = document.createElement('span');
      col.className = 'cc-odo__digit';
      const strip = document.createElement('span');
      strip.className = 'cc-odo__strip';
      const steps = loops * 10 + target;
      for (let v = 0; v <= steps; v++) {
        const cell = document.createElement('span');
        cell.textContent = String(v % 10);
        strip.appendChild(cell);
      }
      col.appendChild(strip);
      numEl.appendChild(col);
      strips.push([strip, steps]);
    });
    /* paint at 0, then roll every column to its stop */
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        strips.forEach(([strip, steps]) => {
          strip.style.transform = 'translateY(-' + steps + 'em)';
        });
      });
    });
  }

  function findPoints() {
    /* preferred: the LL SDK object */
    try {
      const c = window.loyaltylion && window.loyaltylion.customer;
      if (c && typeof c.points_approved === 'number') {
        return { ok: c.points_approved, pending: c.points_pending || 0 };
      }
    } catch (e) {
      /* fall through to DOM parse */
    }
    /* fallback: parse the (CSS-hidden) LL headers. Scan ALL of them and
       prefer the explicit balance phrasing — the guest header's 'Get
       250 Stars just for signing up' poisoned a first-match parse. */
    const hdrs = Array.from(document.querySelectorAll('.lion-header'));
    const texts = hdrs.map((h) => h.textContent.replace(/\s+/g, ' '));
    for (const pattern of [/You have\s*([\d,]+)/i, /([\d,]+)\s*Stars?/i]) {
      for (const text of texts) {
        const m = text.match(pattern);
        if (m) {
          const p = text.match(/\((\d[\d,]*)\s*pending\)/i);
          return {
            ok: parseInt(m[1].replace(/,/g, ''), 10),
            pending: p ? parseInt(p[1].replace(/,/g, ''), 10) : 0,
          };
        }
      }
    }
    return null;
  }

  /* Tier progress (Tony 2026-07-13: two milestone balls, Rise + Summit,
     replacing the voucher ladder). Spend comes server-side from
     customer.total_spent; if LL's live tier disagrees (LL may window
     spend differently), the LL tier wins and the spend is clamped into
     that tier's range so bar, badge and text never contradict. */
  const RISE_AT = 100;
  const SUMMIT_AT = 300;
  let llTier = null; // set by memberTierPolish when LL hydrates
  const fmtMoney = (n) => '$' + (Math.round(n * 100) / 100).toFixed(2).replace(/\.00$/, '');
  function paintProgress() {
    const wrap = root.querySelector('[data-cc-progress]');
    if (!wrap) return;
    const fill = wrap.querySelector('[data-cc-progress-fill]');
    const text = wrap.querySelector('[data-cc-progress-text]');
    let spend = (parseInt(wrap.dataset.ccSpendCents || '0', 10) || 0) / 100;
    let clampedDown = false; // LL says lower tier than lifetime spend implies
    if (llTier === 'Summit') spend = Math.max(spend, SUMMIT_AT);
    else if (llTier === 'Rise' && spend >= SUMMIT_AT) { spend = (RISE_AT + SUMMIT_AT) / 2; clampedDown = true; }
    else if (llTier === 'Rise') spend = Math.max(spend, RISE_AT);
    else if (llTier === 'Start' && spend >= RISE_AT) { spend = RISE_AT / 2; clampedDown = true; }
    let pct, msg;
    if (spend >= SUMMIT_AT) {
      pct = 100;
      msg = "You've reached Summit — our top tier";
    } else if (spend >= RISE_AT) {
      pct = 50 + ((spend - RISE_AT) / (SUMMIT_AT - RISE_AT)) * 50;
      msg = clampedDown
        ? 'Keep shopping to reach Summit'
        : 'Spend ' + fmtMoney(SUMMIT_AT - spend) + ' more to reach Summit';
    } else {
      pct = Math.max(3, (spend / RISE_AT) * 50);
      msg = clampedDown
        ? 'Keep shopping to reach Rise'
        : 'Spend ' + fmtMoney(RISE_AT - spend) + ' more to reach Rise';
    }
    text.textContent = msg;
    const riseDot = wrap.querySelector('[data-cc-dot="rise"]');
    const summitDot = wrap.querySelector('[data-cc-dot="summit"]');
    if (riseDot) riseDot.classList.toggle('cc-rewards__progress-dot--done', spend >= RISE_AT);
    if (summitDot) summitDot.classList.toggle('cc-rewards__progress-dot--done', spend >= SUMMIT_AT);
    const riseMark = wrap.querySelector('[data-cc-mark="rise"]');
    const summitMark = wrap.querySelector('[data-cc-mark="summit"]');
    if (riseMark) riseMark.classList.toggle('cc-rewards__progress-mark--done', spend >= RISE_AT);
    if (summitMark) summitMark.classList.toggle('cc-rewards__progress-mark--done', spend >= SUMMIT_AT);
    wrap.hidden = false;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        fill.style.width = pct + '%';
      });
    });
  }
  paintProgress(); // server data — no LL wait

  /* homepage-grade entry: per-item cc-reveal with stagger (LL content
     hydrates late, so this re-runs from tick()) */
  const reduced2 = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealIO = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        e.target.classList.add('cc-reveal--in');
        revealIO.unobserve(e.target);
        setTimeout(() => (e.target.style.transitionDelay = ''), 900);
      });
    },
    { threshold: 0.08 }
  );
  function wireReveals() {
    if (reduced2) return;
    const items = document.querySelectorAll(
      '.lion-reward-item, .lion-rule-item, .lion-faq__item, .cc-rewards__step, .cc-rewards__tier, .cc-rewards__tile'
    );
    let i = 0;
    items.forEach((el) => {
      if (el.dataset.ccRev) return;
      el.dataset.ccRev = '1';
      if (el.getBoundingClientRect().top < window.innerHeight) return; // on-load content never animates
      el.classList.add('cc-reveal');
      el.style.transitionDelay = (i % 5) * 55 + 'ms';
      i += 1;
      revealIO.observe(el);
    });
  }

  /* member polish (Tony round 7): the 'Your ChinChile Rewards status'
     LL section goes away — its one fact (current tier) becomes a badge
     on our matching tier card. Class names unknown (member-only DOM) →
     match by heading text, defensively. */
  function memberTierPolish() {
    document.querySelectorAll('.lion-integrated-page-section').forEach((sec) => {
      if (sec.dataset.ccStatusDone) return;
      const h = sec.querySelector('.lion-integrated-page-section__heading-text');
      if (!h || !/rewards status/i.test(h.textContent)) return;
      sec.dataset.ccStatusDone = '1';
      let tier = null;
      try {
        const t = window.loyaltylion && window.loyaltylion.customer &&
          window.loyaltylion.customer.loyalty_tier_membership;
        tier = t && t.loyalty_tier && t.loyalty_tier.name;
      } catch (e) { /* fall through */ }
      if (!tier) {
        const cur = sec.querySelector("[class*='current'], [class*='active']");
        const m = ((cur || sec).textContent.match(/\b(Start|Rise|Summit)\b/) || [])[1];
        tier = m || null;
      }
      sec.style.display = 'none';
      if (tier && /^(Start|Rise|Summit)$/.test(tier)) {
        llTier = tier;
        paintProgress(); // re-verdict the bar with LL's live tier
      }
      if (tier) {
        const card = document.querySelector('.cc-rewards__tier--' + tier.toLowerCase());
        if (card && !card.querySelector('.cc-rewards__tier-badge')) {
          const b = document.createElement('span');
          b.className = 'cc-rewards__tier-badge';
          b.textContent = 'Your tier';
          card.appendChild(b);
        }
      }
    });
  }

  /* ---- FAQ rebuilt from the ground up (Tony round 10): LL's FAQ
     content (dashboard-managed) is lifted out of its DOM and rebuilt
     as OUR accordion — one open at a time, grid-rows animation. ---- */
  function rebuildFaq() {
    const src = document.querySelector('.lion-faq');
    if (!src || src.dataset.ccRebuilt) return;
    const items = src.querySelectorAll('.lion-faq-list__item');
    if (!items.length) return; // LL not hydrated yet
    src.dataset.ccRebuilt = '1';
    const wrap = document.createElement('div');
    wrap.className = 'cc-rewards__faq';
    const h = document.createElement('h2');
    h.className = 'cc-rewards__section-heading';
    h.textContent = 'Frequently asked questions';
    wrap.appendChild(h);
    let built = 0;
    items.forEach((it) => {
      const qEl = it.querySelector('.lion-faq-list__question-summary') || it.querySelector('.lion-faq-list__question');
      const aEl = it.querySelector("[class*='answer']") || (qEl && qEl.nextElementSibling);
      if (!qEl || !aEl) return;
      const item = document.createElement('div');
      item.className = 'cc-rewards__faq-item';
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cc-rewards__faq-q';
      btn.setAttribute('aria-expanded', 'false');
      const label = document.createElement('span');
      label.textContent = qEl.textContent.trim();
      btn.appendChild(label);
      btn.insertAdjacentHTML(
        'beforeend',
        '<svg viewBox="0 0 12 7" fill="none" aria-hidden="true"><path d="m1 1 5 5 5-5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      );
      const a = document.createElement('div');
      a.className = 'cc-rewards__faq-a';
      const clip = document.createElement('div');
      clip.className = 'cc-rewards__faq-clip';
      clip.innerHTML = aEl.innerHTML; // LL-managed store content
      a.appendChild(clip);
      item.appendChild(btn);
      item.appendChild(a);
      wrap.appendChild(item);
      built += 1;
    });
    if (!built) return;
    src.parentNode.insertBefore(wrap, src);
    src.style.display = 'none';
    wrap.addEventListener('click', (e) => {
      const btn = e.target.closest('.cc-rewards__faq-q');
      if (!btn) return;
      const wasOpen = btn.getAttribute('aria-expanded') === 'true';
      wrap.querySelectorAll('.cc-rewards__faq-q[aria-expanded="true"]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
      if (!wasOpen) btn.setAttribute('aria-expanded', 'true');
    });
  }

  /* ---- 'Your rewards' gets a full-bleed band (class unknown —
     heading-matched) ---- */
  function bandClaimed() {
    document.querySelectorAll('.lion-integrated-page-section').forEach((sec) => {
      if (sec.dataset.ccBand) return;
      const h = sec.querySelector('.lion-integrated-page-section__heading-text');
      if (h && /^\s*your rewards/i.test(h.textContent)) {
        sec.dataset.ccBand = '1';
        sec.classList.add('cc-rewards__band');
      }
    });
  }

  /* ---- voucher tap focus: dim + blur the page (homepage variant-
     modal language) with the tapped card elevated ---- */
  let focusOv = null;
  function closeFocus() {
    if (!focusOv) return;
    const ov = focusOv;
    focusOv = null;
    ov.classList.remove('cc-reward-focus--on');
    document.querySelectorAll('.cc-reward-focused').forEach((c) => c.classList.remove('cc-reward-focused'));
    setTimeout(() => ov.remove(), 260);
  }
  document.addEventListener('click', (e) => {
    /* LL popup close buttons release the focus dim */
    if (focusOv && e.target.closest("[class*='lion-'] [class*='close'], [class*='lion-'][class*='close']")) {
      closeFocus();
      return;
    }
    /* redeem cards AND claimed cards ('Your rewards' — different class
       token, which is why the dim never fired there: Tony round 11) */
    const card = e.target.closest(".lion-reward-item, [class*='claimed-reward-item']");
    if (card && !focusOv) {
      focusOv = document.createElement('div');
      focusOv.className = 'cc-reward-focus';
      focusOv.addEventListener('click', closeFocus);
      document.body.appendChild(focusOv);
      card.classList.add('cc-reward-focused');
      setTimeout(() => focusOv && focusOv.classList.add('cc-reward-focus--on'), 20);
    } else if (
      focusOv &&
      !e.target.closest(
        '.lion-reward-item, [class*="claimed-reward-item"], [class*="lion-modal"], [class*="lion-dialog"], [class*="lion-claim"], [class*="lion-popover"]'
      )
    ) {
      closeFocus();
    }
    /* CAPTURE phase: LL stops propagation of REAL pointer clicks inside
       its cards — the bubble-phase listener never fired for actual taps
       (synthetic test clicks bubbled fine, which hid this: Tony r12) */
  }, true);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeFocus();
  });

  let tries = 0;
  const tick = () => {
    pruneTiles();
    wireReveals();
    memberTierPolish();
    rebuildFaq();
    bandClaimed();
    if (numEl && !rolled) {
      const pts = findPoints();
      if (pts) {
        roll(pts.ok);
        if (pendEl && pts.pending > 0) {
          pendEl.hidden = false;
          pendEl.textContent = '(' + fmt(pts.pending) + ' pending)';
        }
      }
    }
    /* LL lands late; keep checking for ~20s, then settle for whatever
       state we have (tiles pruned to reality either way) */
    tries += 1;
    if (tries < 40 && (!rolled || tries < 6)) setTimeout(tick, 500);
  };
  tick();
})();
